export const FEEDBACK_TYPE = {
  A: "사무직 대상",
  B: "현장직 대상",
};
